import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Redirect } from "react-router";
import PageContent from "@my-dld/components/PageContent";
import { ImperialSystem, MetricSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import { dispatch, navigate, navigateWithInParent, replaceNavigate } from "@my-dld/utils/StoreUtils";
import { EjariDetails } from "../PropertyDetails";
import Strings from "@my-dld/assets/strings";
import { ServiceCard } from "@my-dld/components/ServiceContainer";
import { downloadTenancyContractByNumber } from "@my-dld/actions/PropertyActions";
import { canDoContractOperations } from "@eres/ejari-api/EjariPropertyUtil";
import { resetTenantContractContext, updateTenantContractContext } from "@eres/ejari-core/contexts/TenantContractContext";
import { TenancyContactAction } from "@eres/ejari-core/constants";
import { EjariProperty, EjariPropertyUsage } from "@eres/ejari-api/Entity";
import DetailsKV from "../../component/DetailsKV";
import { formatAppDate } from "@my-dld/utils/Utils";
import { toFormattedCurrency } from "@eres/core/dist/Currency";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { validateProperty, verifyTenantUserProfile } from "../../component/TenantContract/PropertyDetails";
import { EjariApi } from "@eres/ejari-api";
import { TenantContractInfo } from "@eres/ejari-api/Entity/tenant";
import { TenantReqDetailsRequest } from "@eres/ejari-api/IApi";
import { TenantContext } from "@eres/ejari-core/contexts/TenantContext";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { DashboardBCItem, LeaseDetailsBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import Switch from "@my-dld/components/Switch";
import Actions from "@my-dld/actions";
import { extractPropInfo } from "../../component/PropertyHeader";
import { getAppServices } from "@10x/coreapp";
import { EjariPropertyFromTenantRequest } from "@eres/ejari-api/Utils";
import { CoOccupants } from "../../component/CoOccupant/CoOccupants";
import { Gated } from "@10x/feature-gate";
import { Pets } from "../../component/CoOccupant/Pets";
import { JOPUserType } from "@my-dld/screens/JOPServices";
import { JopGateAPI } from "@my-dld/screens/JOPServices/Api";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { OwnerCommitteeApi } from "../../../../ownercommitteeapi";
import { IJOPServices } from "@my-dld/screens/JOPServices/JOPService";
import { getJOPServicesTenant } from "@my-dld/screens/JOPServices/Api/api";

interface Props extends RoutedViewProps {

}

interface State {
	unit: UnitSystem;
	canDownload: boolean;
	showJOP?: boolean;
	jopServices? : IJOPServices;
}

class LeaseDetails extends Component<Props, State> {
	static contextType = TenantContext;
	context!: React.ContextType<typeof TenantContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			unit: getAppServices().storeService.getStore().getState().User.unit,
			canDownload: false,
		};
	}

	componentDidMount(): void {
		this.updateFromContext();
		const { property } = this.context;
		JopGateAPI.getJOPServicesTenant( TabuProfile.getParticipantNumber()!, property?.PropertyId! )
		.then( r => {
			if ( r && r.validationErrorsList && r.validationErrorsList.length > 0 ) {
				showErrorMessage( OwnerCommitteeApi.getValidationError( r.validationErrorsList ) );
			} else if ( r && r.response && r.response ) {
				this.setState( { showJOP: r.response.canInquiry || r.response.canLegal || r.response.canSuggestion || r.response.canComplaint  ,
					jopServices: {
						canInquiry:  r.response.canInquiry,
						canLegal: r.response.canLegal,
						canComplaint: r.response.canComplaint,
						canSuggestion: r.response.canSuggestion,
					}} );
			}
		} )
		.catch( reason => {
			showErrorMessage( reason );
		} );
	}

	handleServiceAction = ( id: string ) => {
		const { property } = this.context;
		switch ( id ) {
			case "download_contract":
				if ( property ) {
					let currentContract = property?.CurrentContract;
					downloadTenancyContractByNumber( currentContract?.ContractNumber!, currentContract?.ContractKey! );
				}
				break;
			case "renew_contract":
				this.onValidateProperty( TenancyContactAction.RENEW_CONTRACT );
				break;
			case "terminate_contract":
				this.onValidateProperty( TenancyContactAction.TERMINATE_CONTRACT );
				break;
			case "manage_co_occupant":
				navigateWithInParent( "lease", `cooccupants` );
				break;
			case "manage_pets":
				navigateWithInParent( "lease", `pets` );
				break;
			case "mollak_services":
				navigate( `/mydld/jop`, undefined, { property: property , userType :  JOPUserType.TENANT, jopServices: this.state.jopServices } );
				break;
		}
	};

	DownloadService = {
		id: "download_contract",
		label: Strings.download_contract,
		action: this.handleServiceAction,
		allowUnverifiedEmailUsers: true,
	};
	RenewContractService = {
		id: "renew_contract",
		label: Strings.renew_contract,
		action: this.handleServiceAction,
		allowUnverifiedEmailUsers: false,
	};
	TerminateContractService = {
		id: "terminate_contract",
		label: Strings.terminate_contract,
		action: this.handleServiceAction,
		allowUnverifiedEmailUsers: false,
	};
	ManageCoOccupantService = {
		id: "manage_co_occupant",
		label: Strings.manage_co_occupants,
		action: this.handleServiceAction,
		allowUnverifiedEmailUsers: false,
		requiredFeature: "ejariCoOccupants",
	};
	ManagePetsService = {
		id: "manage_pets",
		label: Strings.manage_pets,
		action: this.handleServiceAction,
		allowUnverifiedEmailUsers: false,
		requiredFeature: "ejariCoOccupantPets",
	};
	MollakServices = {
		id: "mollak_services",
		label: Strings.jop_services,
		action: this.handleServiceAction,
		allowUnverifiedEmailUsers: false,
		// requiredFeature: "ejariCoOccupantPets",
	};

	render() {
		const { property } = this.context;
		const { unit, canDownload } = this.state;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		let { val, lbl } = extractPropInfo( property );
		const services: ServiceCard[] = [];
		if ( canDownload ) {
			services.push( this.DownloadService );
		}
		const lastContract = property!.CurrentContract;
		if ( canDownload && lastContract.ContractTypeId === 2 ) {
			services.push( this.RenewContractService );
			services.push( this.TerminateContractService );
		}
		const hasCoOccupant = property.EjariUsageId === EjariPropertyUsage.RESIDENTIAL;
		if ( hasCoOccupant ) {
			services.push( this.ManageCoOccupantService );
			services.push( this.ManagePetsService );
		}
		// SOHRAB TODO
		if( this.state.showJOP ) services.push( this.MollakServices );


		return <PageContent
			serviceTitle={ Strings.property_services }
			services={ services }
			title={ Strings.property_details + " - " + lbl + " : " + val }
            contentClass={"col-md-12 mb-3"}
			titleExtra={ <Switch
				id={ "result-unit" }
				onLabel={ Strings.sq_mt }
				offLabel={ Strings.sq_ft }
				value={ this.state.unit.Id === MetricSystem.Id }
				onChange={ isSqm => {
					const update = { unit: ImperialSystem };
					if ( isSqm ) update.unit = MetricSystem;
					this.setState( update, () => {
						dispatch( Actions.UNIT_CHANGED, this.state.unit );
					} );
				} }
            />}>
            <div className="tabs mydld-property-detail-tab">
                <nav className="transformer-tabs">
                    <ul id="myTab" role="tablist">
                        <li className="nav-item">
                            <a href="#" className="nav-link active" id="property_details-tab" data-bs-toggle="tab" data-bs-target="#property_details-tab-pane" type="button" role="tab" aria-controls="property_details-tab-pane" aria-selected="true">{Strings.lease_details}</a>
                        </li>
                        <li className="nav-item">
                            <a href="#" className="nav-link" id="contract_details-tab" data-bs-toggle="tab" data-bs-target="#contract_details-tab-pane" type="button" role="tab" aria-controls="contract_details-tab-pane" aria-selected="false">{Strings.contract_details}</a>
                        </li>
                        {hasCoOccupant &&
                            <li className="nav-item">
                            <a href="#" className="nav-link" id="coOccupant_details-tab" data-bs-toggle="tab" data-bs-target="#coOccupant_details-tab-pane" type="button" role="tab"
                                    aria-controls="coOccupant_details-tab-pane" aria-selected="false">{Strings.co_occupant_details}</a>
                            </li>
                        }

                    </ul>
                </nav>
                <div className="tab-content d-flex pt-0 " id="myTabContent">
                    <div className="tab-pane fade show active" id="property_details-tab-pane" role="tabpanel" aria-labelledby="property_details-tab">
                        <EjariDetails
                            showTitle={false}
                            showRentalStatus={true}
                            property={property}
                            unit={unit} />
                    </div>
                    <div className="tab-pane fade" id="contract_details-tab-pane" role="tabpanel" aria-labelledby="contract_details-tab">
                        <ContractDetails property={property} />
                    </div>
                    {hasCoOccupant &&
                        <>
                            <div className="tab-pane fade" id="coOccupant_details-tab-pane" role="tabpanel" aria-labelledby="coOccupant_details-tab">
                                <Gated featureId={"ejariCoOccupants"}>
                                    <CoOccupants
                                        contractId={property.CurrentContract.ContractId}
                                        contractType={property.CurrentContract.ContractTypeId} />
                                </Gated>
                                <Gated featureId={"ejariCoOccupantPets"}>
                                    <Pets
                                        contractId={property.CurrentContract.ContractId}
                                        contractType={property.CurrentContract.ContractTypeId} />
                                </Gated>
                            </div>
                        </>
                    }
                </div>
            </div>
            
            
			<PageTitle title={ Strings.lease_details } paths={ [ DashboardBCItem, LeaseDetailsBCItem ] }/>
		</PageContent>;
	}


	private onValidateProperty( action: TenancyContactAction ) {
		showLoading();
		const { property } = this.context;
		validateProperty( property!, [ 7, 2 ] ).then( ( _resp: { property: EjariProperty } ) => {
			this.onVerifyTenantUserProfile( action );
		} ).catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	};

	private getContract( tenantId: number, action: TenancyContactAction ) {
		const { property } = this.context;
		const lastContract = property!.CurrentContract;
		const req: TenantReqDetailsRequest = {
			ContractType: lastContract.ContractTypeId,
			ContractID: lastContract.ContractId,
		};
		EjariApi.getTenantRequestDetail( req ).then( ( resp: TenantContractInfo ) => {
			hideLoading();
			this.onAction( tenantId, resp, action );
		} ).catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	}

	private onAction( tenantId: number, contract: TenantContractInfo, action: TenancyContactAction ) {
		const { property, AllowedCoTenants } = this.context;
		const data = { property: property, tenantId: tenantId, contract: contract, action: action, AllowedCoTenants: AllowedCoTenants };
		if ( contract.Properties && contract.Properties.length > 0 ) {
			data.property = EjariPropertyFromTenantRequest( contract.Properties[ 0 ] );
		}
		if ( AllowedCoTenants === undefined ) {
			const lastContract = property!.CurrentContract;
			showLoading();
			EjariApi.getCoOccupants( lastContract.ContractId!, lastContract.ContractTypeId! )
			.then( x => {
				hideLoading();
				data.AllowedCoTenants = x.AllowedCoTenants;
				resetTenantContractContext();
				updateTenantContractContext( data );
				navigateWithInParent( "tenant",
					`contract/${ ( action === TenancyContactAction.RENEW_CONTRACT ) ? "renew" : "terminate" }` );
			} )
			.catch( e => {
				hideLoading();
				showErrorMessage( e );
			} );
		} else {
			resetTenantContractContext();
			updateTenantContractContext( data );
			navigateWithInParent( "tenant",
				`contract/${ ( action === TenancyContactAction.RENEW_CONTRACT ) ? "renew" : "terminate" }` );
		}
	}

	private updateFromContext() {
		const { property, actionDone } = this.context;
		if ( actionDone ) {
			replaceNavigate( "/mydld" );
		} else if ( property ) {
			trackEventWithData( "TenantEjariProperty", "View", {
				type: property.PropertyTypeId,
				id: property.PropertyId
			} );
			const lastContract = property.CurrentContract;
			const canDownload = canDoContractOperations( lastContract );
			this.setState( {
				canDownload: canDownload,
			} );
		}
	}


	private onVerifyTenantUserProfile( action: TenancyContactAction ) {
		verifyTenantUserProfile().then( ( tenantId: number | undefined ) => {
			if ( tenantId && tenantId !== 0 ) {
				this.getContract( tenantId, action );
			} else {
				hideLoading();
				showErrorMessage( Strings.tenant_verify_error );
			}
		} ).catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	}
}

function ContractDetails( props: { property: EjariProperty } ) {
	const { property } = props;
	const contract = property.CurrentContract;
	if ( contract ) {
		return <React.Fragment>
            {/*<div className="section-title">
				<h5>{ Strings.contract_details }</h5>
			</div>*/}
			<div className="flex-grid">
				<DetailsKV label={ Strings.contract_number } value={ contract.ContractNumber }/>
				<DetailsKV label={ Strings.start_date } value={ formatAppDate( contract.ContractStartDate ) }/>
				<DetailsKV label={ Strings.end_date } value={ formatAppDate( contract.ContractEndDate ) }/>
				{ contract.GraceStartDate &&
					<DetailsKV label={ Strings.grace_start_date } value={ formatAppDate( contract.GraceStartDate ) }/> }
				{ contract.GraceEndDate &&
					<DetailsKV label={ Strings.grace_end_date } value={ formatAppDate( contract.GraceEndDate ) }/> }
				<DetailsKV
					label={ Strings.rental_amount }
					value={ toFormattedCurrency( contract.ContractAmount! ) + " " + Strings.aed }/>
				{ contract.SecurityDeposit != null &&
					<DetailsKV
						label={ Strings.security_deposit }
						value={ toFormattedCurrency( Number( contract.SecurityDeposit! ) ) + " " + Strings.aed }/> }
				<DetailsKV label={ Strings.status } value={ property.ContractStatusName }/>
			</div>
		</React.Fragment>;
	}
	return null;
}

export default LeaseDetails;
